(function () {
  'use strict';

  function initBeellyDrawer() {
    var drawer = document.getElementById('BeellyCartDrawer');

    if (!drawer || window.__BEELLY_DRAWER_INIT__) return;
    window.__BEELLY_DRAWER_INIT__ = true;

    var body = document.body;
    var itemsEl = document.getElementById('BeellyCartDrawerItems');
    var subtotalEl = document.getElementById('BeellyCartDrawerSubtotal');
    var emptyEl = document.getElementById('BeellyCartDrawerEmpty');
    var loadingEl = document.getElementById('BeellyCartDrawerLoading');
    var footerEl = document.getElementById('BeellyCartDrawerFooter');
    var drawerBody = document.getElementById('BeellyCartDrawerBody');

    var shopifyRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root;

    var language = (
      drawer.getAttribute('data-language') ||
      document.documentElement.lang ||
      'it'
    ).toLowerCase().slice(0, 2);

    var isGerman =
      language === 'de' ||
      /^\/de(?:[-/]|$)/i.test(window.location.pathname) ||
      /^\/de(?:[-/]|$)/i.test(shopifyRoot || '');

    var root = shopifyRoot || (isGerman ? '/de/' : '/');

    if (root.charAt(root.length - 1) !== '/') {
      root += '/';
    }

    var texts = isGerman
      ? {
          remove: 'Entfernen',
          minus: 'Menge verringern',
          plus: 'Menge erhöhen',
          quantity: 'Menge',
          added: 'Zum Warenkorb hinzugefügt',
          error:
            'Die Änderung konnte nicht gespeichert werden. Bitte versuche es erneut.',
          addError:
            'Der Artikel konnte nicht hinzugefügt werden.',
          loading: 'Warenkorb wird aktualisiert…'
        }
      : {
          remove: 'Rimuovi',
          minus: 'Diminuisci quantità',
          plus: 'Aumenta quantità',
          quantity: 'Quantità',
          added: 'Aggiunto al carrello',
          error: 'La modifica non è stata salvata. Riprova.',
          addError:
            'Non è stato possibile aggiungere il prodotto.',
          loading: 'Aggiornamento carrello…'
        };

    var busy = false;
    var activeCurrency = 'EUR';
    var previousFocus = null;

    var errorEl = document.createElement('p');
    errorEl.className = 'beelly-drawer__error';
    errorEl.setAttribute('role', 'alert');
    errorEl.hidden = true;
    errorEl.style.cssText =
      'padding:12px 16px;color:#8b2626;font-size:14px;line-height:1.5;';

    if (drawerBody) drawerBody.prepend(errorEl);
    if (loadingEl) loadingEl.textContent = texts.loading;

    if (!document.getElementById('BeellyDrawerRemoveStyles')) {
      var style = document.createElement('style');
      style.id = 'BeellyDrawerRemoveStyles';

      style.textContent =
        '#BeellyCartDrawer .beelly-drawer__row{' +
          'display:flex;' +
          'align-items:center;' +
          'gap:8px;' +
          'flex-wrap:wrap;' +
        '}' +
        '#BeellyCartDrawer .beelly-drawer__qty{' +
          'display:inline-flex;' +
          'align-items:center;' +
          'flex:0 0 auto;' +
        '}' +
        '#BeellyCartDrawer .beelly-drawer__price{' +
          'margin-left:auto;' +
        '}' +
        '#BeellyCartDrawer .beelly-drawer__remove{' +
          'display:inline-flex!important;' +
          'align-items:center!important;' +
          'justify-content:center!important;' +
          'width:44px!important;' +
          'min-width:44px!important;' +
          'height:44px!important;' +
          'padding:10px!important;' +
          'margin:0!important;' +
          'flex:0 0 44px;' +
          'background:#fff8ef!important;' +
          'color:#75420d!important;' +
          'border:1px solid #e8cba8!important;' +
          'border-radius:12px!important;' +
          'cursor:pointer;' +
          'text-decoration:none!important;' +
          'box-sizing:border-box;' +
        '}' +
        '#BeellyCartDrawer .beelly-drawer__remove:hover{' +
          'background:#fcebd4!important;' +
        '}' +
        '#BeellyCartDrawer .beelly-drawer__remove:focus-visible{' +
          'outline:2px solid #75420d;' +
          'outline-offset:3px;' +
        '}' +
        '#BeellyCartDrawer .beelly-drawer__remove:disabled{' +
          'opacity:.5;' +
          'cursor:wait;' +
        '}' +
        '#BeellyCartDrawer .beelly-drawer__remove svg{' +
          'display:block;' +
          'width:24px;' +
          'height:24px;' +
          'pointer-events:none;' +
        '}';

      document.head.appendChild(style);
    }

    function endpoint(path) {
      return root + path;
    }

    function localizedProductUrl(value) {
      try {
        var url = new URL(value || '', window.location.origin);

        if (url.origin !== window.location.origin) {
          return url.href;
        }

        var productPosition = url.pathname.indexOf('/products/');

        if (productPosition >= 0) {
          return (
            root.replace(/\/$/, '') +
            url.pathname.slice(productPosition) +
            url.search +
            url.hash
          );
        }

        return url.pathname + url.search + url.hash;
      } catch (error) {
        return endpoint('cart');
      }
    }

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(
          isGerman ? 'de-DE' : 'it-IT',
          {
            style: 'currency',
            currency: activeCurrency
          }
        ).format(Number(cents || 0) / 100);
      } catch (error) {
        return (
          '€' +
          (Number(cents || 0) / 100)
            .toFixed(2)
            .replace('.', ',')
        );
      }
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function sizedImage(value) {
      if (!value) return '';

      try {
        var url = new URL(value, window.location.origin);
        url.searchParams.set('width', '180');
        return url.href;
      } catch (error) {
        return value;
      }
    }

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = !message;
    }

    function setLoading(loading) {
      if (loadingEl) loadingEl.hidden = !loading;

      if (drawerBody) {
        drawerBody.setAttribute(
          'aria-busy',
          loading ? 'true' : 'false'
        );
      }

      if (itemsEl) {
        itemsEl.querySelectorAll('button, input')
          .forEach(function (element) {
            element.disabled = loading;
          });
      }
    }

    function updateCounts(cart) {
      var count =
        cart && typeof cart.item_count === 'number'
          ? cart.item_count
          : 0;

      document.querySelectorAll(
        '[data-cart-count], #CartCount, .cart-count'
      ).forEach(function (element) {
        element.textContent = String(count);
      });
    }

    function focusableElements() {
      return Array.prototype.slice.call(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), ' +
          'input:not([disabled]), select:not([disabled]), ' +
          'textarea:not([disabled]), [tabindex="0"]'
        )
      ).filter(function (element) {
        return (
          element.getAttribute('tabindex') !== '-1' &&
          element.getClientRects().length > 0
        );
      });
    }

    function openDrawer() {
      var alreadyOpen = drawer.classList.contains('is-open');

      if (!alreadyOpen) {
        previousFocus = document.activeElement;
      }

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('beelly-drawer-open');

      if (!alreadyOpen) {
        var closeButton = drawer.querySelector(
          'button[data-beelly-drawer-close]'
        );

        if (closeButton) closeButton.focus();
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      body.classList.remove('beelly-drawer-open');

      if (previousFocus && document.contains(previousFocus)) {
        previousFocus.focus();
      }
    }

    async function fetchCart() {
      var response = await fetch(endpoint('cart.js'), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Cart request failed');
      }

      return response.json();
    }

    function renderCart(cart) {
      if (!cart || !itemsEl) return;

      var focusedElement = document.activeElement;
      var focusedKey = null;
      var focusedKind = null;

      if (focusedElement && itemsEl.contains(focusedElement)) {
        var focusedRow = focusedElement.closest('[data-line]');
        var focusedRemove = focusedElement.closest('[data-remove]');

        if (focusedRemove) {
          focusedKey = focusedRemove.getAttribute('data-remove');
          focusedKind = 'remove';
        } else if (focusedRow) {
          focusedKey = focusedRow.getAttribute('data-line');
          focusedKind =
            focusedElement.getAttribute('data-qty') || 'input';
        }
      }

      activeCurrency = cart.currency || 'EUR';
      updateCounts(cart);
      itemsEl.innerHTML = '';

      var items = cart.items || [];
      var isEmpty = items.length === 0;

      if (emptyEl) emptyEl.hidden = !isEmpty;
      if (footerEl) footerEl.style.display = isEmpty ? 'none' : '';

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(
          cart.items_subtotal_price != null
            ? cart.items_subtotal_price
            : cart.total_price
        );
      }

      items.forEach(function (item) {
        var element = document.createElement('div');
        element.className = 'beelly-drawer__item';
        element.setAttribute('role', 'listitem');

        var title = item.product_title || item.title || '';
        var url = localizedProductUrl(item.url);
        var image = sizedImage(item.image);
        var variantTitle = item.variant_title || '';

        if (
          /^(default title|standard-title|standard-name)$/i
            .test(variantTitle)
        ) {
          variantTitle = '';
        }

        var imageMarkup = image
          ? '<a href="' + escapeHtml(url) +
              '" tabindex="-1" aria-hidden="true">' +
              '<img class="beelly-drawer__img" src="' +
                escapeHtml(image) +
                '" alt="" loading="lazy">' +
            '</a>'
          : '';

        var trashIcon =
          '<svg xmlns="http://www.w3.org/2000/svg"' +
            ' width="24" height="24" viewBox="0 0 24 24"' +
            ' fill="none" stroke="currentColor"' +
            ' stroke-width="1.8" stroke-linecap="round"' +
            ' stroke-linejoin="round"' +
            ' aria-hidden="true" focusable="false">' +
            '<path d="M9 5V3.8A1.3 1.3 0 0 1 10.3 2.5h3.4' +
              'A1.3 1.3 0 0 1 15 3.8V5"></path>' +
            '<rect x="3.5" y="5" width="17" height="3.5"' +
              ' rx="1"></rect>' +
            '<path d="M5.5 8.5l.8 11.3A1.8 1.8 0 0 0 8.1 21.5' +
              'h7.8a1.8 1.8 0 0 0 1.8-1.7l.8-11.3"></path>' +
            '<path d="M10 12v6M14 12v6"></path>' +
          '</svg>';

        element.innerHTML =
          imageMarkup +
          '<div class="beelly-drawer__meta">' +
            '<a class="beelly-drawer__name" href="' +
              escapeHtml(url) + '">' +
              escapeHtml(title) +
            '</a>' +
            (
              variantTitle
                ? '<div class="beelly-drawer__variant">' +
                    escapeHtml(variantTitle) +
                  '</div>'
                : ''
            ) +
            '<div class="beelly-drawer__row">' +

              '<button type="button"' +
                ' class="beelly-drawer__remove" data-remove="' +
                escapeHtml(item.key) + '"' +
                ' aria-label="' +
                escapeHtml(texts.remove + ': ' + title) + '"' +
                ' title="' + escapeHtml(texts.remove) + '">' +
                trashIcon +
              '</button>' +

              '<div class="beelly-drawer__qty" data-line="' +
                escapeHtml(item.key) + '">' +
                '<button type="button" data-qty="minus"' +
                  ' aria-label="' +
                  escapeHtml(texts.minus + ': ' + title) +
                  '">−</button>' +
                '<input type="text" value="' +
                  Number(item.quantity || 1) +
                  '" inputmode="numeric" aria-label="' +
                  escapeHtml(texts.quantity + ': ' + title) +
                  '">' +
                '<button type="button" data-qty="plus"' +
                  ' aria-label="' +
                  escapeHtml(texts.plus + ': ' + title) +
                  '">+</button>' +
              '</div>' +

              '<div class="beelly-drawer__price">' +
                escapeHtml(formatMoney(item.final_line_price)) +
              '</div>' +
            '</div>' +
          '</div>';

        itemsEl.appendChild(element);
      });

      setLoading(busy);

      if (focusedKey && drawer.classList.contains('is-open')) {
        var replacement = null;

        itemsEl.querySelectorAll('[data-remove], [data-line]')
          .forEach(function (element) {
            if (
              focusedKind === 'remove' &&
              element.getAttribute('data-remove') === focusedKey
            ) {
              replacement = element;
            } else if (
              focusedKind !== 'remove' &&
              element.getAttribute('data-line') === focusedKey
            ) {
              replacement = focusedKind === 'input'
                ? element.querySelector('input')
                : element.querySelector(
                    '[data-qty="' + focusedKind + '"]'
                  );
            }
          });

        if (replacement) {
          replacement.disabled = false;
          replacement.focus();
        } else {
          var fallback = drawer.querySelector(
            'button[data-beelly-drawer-close]'
          );

          if (fallback) fallback.focus();
        }
      }
    }

    async function refreshAndOpen() {
      if (busy) return;

      busy = true;
      showError('');
      setLoading(true);

      try {
        renderCart(await fetchCart());
        openDrawer();
      } catch (error) {
        window.location.href = endpoint('cart');
      } finally {
        busy = false;
        setLoading(false);
      }
    }

    function showCartToast() {
      var toast = document.getElementById('BeellyCartToast');
      if (!toast) return;

      var message = toast.querySelector(
        '[data-beelly-toast-text]'
      );

      if (message) {
        message.textContent = texts.added;
      } else {
        toast.textContent = '✓ ' + texts.added;
      }

      toast.setAttribute('role', 'status');
      toast.classList.add('is-visible');

      clearTimeout(toast._timer);

      toast._timer = setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2200);
    }

    function flyToCart(form) {
      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }

      var container = form.closest(
        '.beelly-collection-card, .bm-honey, .bs-card, ' +
        '.product-single, .product-item, .product-card, ' +
        'article, .grid__item'
      );

      var image = container && container.querySelector('img');
      var cartButton = document.querySelector(
        '[data-open-cart-drawer], .cart-icon a'
      );

      if (!image || !cartButton) return;

      var start = image.getBoundingClientRect();
      var end = cartButton.getBoundingClientRect();

      if (
        !start.width ||
        !end.width ||
        start.bottom < 0
      ) {
        return;
      }

      var flyingImage = document.createElement('img');
      flyingImage.src = image.currentSrc || image.src;
      flyingImage.alt = '';
      flyingImage.setAttribute('aria-hidden', 'true');

      flyingImage.style.cssText =
        'position:fixed;pointer-events:none;z-index:99999;' +
        'object-fit:contain;border-radius:12px;' +
        'width:80px;height:80px;';

      flyingImage.style.left =
        (start.left + start.width / 2 - 40) + 'px';

      flyingImage.style.top =
        (start.top + start.height / 2 - 40) + 'px';

      body.appendChild(flyingImage);

      if (!flyingImage.animate) {
        flyingImage.remove();
        return;
      }

      var dx =
        end.left + end.width / 2 -
        start.left - start.width / 2;

      var dy =
        end.top + end.height / 2 -
        start.top - start.height / 2;

      var animation = flyingImage.animate(
        [
          {
            transform: 'translate(0,0) scale(1)',
            opacity: 1
          },
          {
            transform:
              'translate(' + dx / 2 + 'px,' +
              (dy / 2 - 80) + 'px) scale(.7)',
            opacity: 0.8
          },
          {
            transform:
              'translate(' + dx + 'px,' + dy +
              'px) scale(.2)',
            opacity: 0
          }
        ],
        {
          duration: 650,
          easing: 'ease-in-out'
        }
      );

      animation.onfinish = function () {
        flyingImage.remove();
      };

      animation.oncancel = function () {
        flyingImage.remove();
      };
    }

    async function addToCart(form) {
      if (busy) return;

      busy = true;
      showError('');
      setLoading(true);

      var submitButtons = form.querySelectorAll(
        'button[type="submit"], input[type="submit"]'
      );

      var originalStates = [];

      submitButtons.forEach(function (button) {
        originalStates.push(button.disabled);
        button.disabled = true;
      });

      try {
        var response = await fetch(endpoint('cart/add.js'), {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        });

        var result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            texts.addError
          );
        }

        flyToCart(form);
        showCartToast();

        try {
          renderCart(await fetchCart());
          openDrawer();
        } catch (refreshError) {
          window.location.href = endpoint('cart');
        }
      } catch (error) {
        showError(error.message || texts.addError);
        openDrawer();
      } finally {
        busy = false;
        setLoading(false);

        submitButtons.forEach(function (button, index) {
          button.disabled = originalStates[index];
        });
      }
    }

    async function changeLineItem(key, quantity) {
      if (busy) return;

      busy = true;
      showError('');
      setLoading(true);

      try {
        var response = await fetch(
          endpoint('cart/change.js'),
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: key,
              quantity: quantity
            })
          }
        );

        var result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            texts.error
          );
        }

        renderCart(await fetchCart());
      } catch (error) {
        showError(error.message || texts.error);

        try {
          renderCart(await fetchCart());
        } catch (refreshError) {
          // Mantiene il contenuto corrente e l'errore.
        }
      } finally {
        busy = false;
        setLoading(false);
      }
    }

    drawer.addEventListener('click', function (event) {
      var target =
        event.target && event.target.closest
          ? event.target
          : event.target && event.target.parentElement;

      if (!target) return;

      if (target.closest('[data-beelly-drawer-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var remove = target.closest('[data-remove]');

      if (remove) {
        event.preventDefault();

        changeLineItem(
          remove.getAttribute('data-remove'),
          0
        );

        return;
      }

      var quantityButton = target.closest('[data-qty]');

      if (quantityButton) {
        event.preventDefault();

        var wrapper = quantityButton.closest('[data-line]');
        var input = wrapper && wrapper.querySelector('input');

        if (!wrapper || !input) return;

        var quantity = parseInt(input.value, 10);

        if (!Number.isFinite(quantity) || quantity < 1) {
          quantity = 1;
        }

        quantity +=
          quantityButton.getAttribute('data-qty') === 'plus'
            ? 1
            : -1;

        changeLineItem(
          wrapper.getAttribute('data-line'),
          Math.max(1, quantity)
        );
      }
    });

    drawer.addEventListener('change', function (event) {
      var input = event.target;

      if (
        !input ||
        !input.matches('.beelly-drawer__qty input')
      ) {
        return;
      }

      var wrapper = input.closest('[data-line]');
      var quantity = parseInt(input.value, 10);

      if (!wrapper) return;

      if (!Number.isFinite(quantity) || quantity < 1) {
        quantity = 1;
      }

      changeLineItem(
        wrapper.getAttribute('data-line'),
        quantity
      );
    });

    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key === 'Tab') {
        var focusable = focusableElements();

        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (
          event.shiftKey &&
          document.activeElement === first
        ) {
          event.preventDefault();
          last.focus();
        } else if (
          !event.shiftKey &&
          document.activeElement === last
        ) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || form.tagName !== 'FORM') return;
      if (form.hasAttribute('data-no-ajax')) return;

      var action = form.getAttribute('action') || '';

      if (action.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!busy) addToCart(form);
    }, true);

    document.addEventListener('click', function (event) {
      var target =
        event.target && event.target.closest
          ? event.target
          : event.target && event.target.parentElement;

      var trigger = target
        ? target.closest('[data-open-cart-drawer]')
        : null;

      if (!trigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      refreshAndOpen();
    }, true);

    window.BeellyCartDrawer = {
      refreshAndOpen: refreshAndOpen,
      close: closeDrawer
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initBeellyDrawer
    );
  } else {
    initBeellyDrawer();
  }
})();